export default __webpack_public_path__ + "static/HammockNature-515effb9fa211693dde9ae033c7cb375.png";